import i18n from 'modules/core/lib/i18n'

import Condition from 'modules/reports/store/models/Condition'

export default function employeeGender(list: string[]): string[] {
  return list.map((value: string) => {
    switch (value) {
      case 'male':
        return i18n.t('custom_reports.especial_filters.employee_gender.options.male')
      case 'female':
        return i18n.t('custom_reports.especial_filters.employee_gender.options.female')
      case Condition.NOT_DEFINED:
        return i18n.t('custom_reports.especial_filters.not_defined')
      default:
        return value
    }
  })
}
